import React, { Component } from 'react';
import { Wrapper, NavLogoWrapper, Container, ScrollContainer } from './styled';
import Logo from '../../Logo';
import { TimesSolid } from '../../Icons';
import MobileMenuButton from '../MobileMenuButton';
import Buttons from '../../Buttons';
import MobileLinks from '../../Links/MobileLinks';
class MobileMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: '1vh',
        };
    }
    componentDidMount() {
        const handleResize = () => {
            const height = window.innerHeight * 0.01;
            this.setState({ height: `${height}px` });
        };
        window.addEventListener('resize', handleResize);
        handleResize();
    }
    render() {
        const { height } = this.state;
        const { hideMobileMenu, links, buttons, contrast } = this.props;
        return (React.createElement(Wrapper, { height: height, contrast: contrast },
            React.createElement(Container, null,
                React.createElement(NavLogoWrapper, null,
                    React.createElement(Logo, { contrast: contrast }),
                    React.createElement(MobileMenuButton, { menuOpened: true, type: "button", onClick: hideMobileMenu, contrast: contrast, "aria-label": "Close Menu" },
                        React.createElement(TimesSolid, null))),
                React.createElement(ScrollContainer, null,
                    React.createElement(MobileLinks, { links: links, contrast: contrast }),
                    React.createElement(Buttons, { isMobile: true, buttons: buttons, contrast: contrast })))));
    }
}
export default MobileMenu;
//# sourceMappingURL=MobileMenu.js.map